import { createAsyncThunk } from '@reduxjs/toolkit'
import { API } from '@shared/api'
import { addTemporaryNotice } from '@widgets/Common/Notices/model/actions'
import {
  appendListUnique,
  setList,
  setLoading,
  setPaginationPage,
  upsertRestaurantInList,
} from '@pages/Listing/model/slice'
import { RootState } from '@app/model/store/client'
import { isRestaurantReadSlug } from '@shared/api/middleware/mappingAPI/restaurant/isRestaurantReadSlug'

const fullRestaurantRequests = new Set<number>()
const LISTING_RESTAURANT_LIST_OPTIMIZED = 2 as const

export const loadMorePage = createAsyncThunk<void, void, { state: RootState }>(
  'listing/loadMorePage',
  async (_, { dispatch, getState }) => {
    const stateGlobal = getState().global
    const state = getState().pages.listing

    const { items_addition, items_full } = state.loading
    const nextPage = state.pagination?.page?.next?.number
    if (items_addition || items_full || !nextPage) return

    dispatch(setLoading({ ...state.loading, items_addition: true }))

    const params = {
      page: nextPage,
      page_size: state.pagination?.page?.size,
      city: stateGlobal.currentCity.id,
      ...state.paramsRequest,
      optimized: LISTING_RESTAURANT_LIST_OPTIMIZED,
    }

    API.restaurant_list({ params })
      .then((response) => {
        dispatch(appendListUnique(response.results))
        dispatch(setPaginationPage(response.pagination))
      })
      .catch((error) => {
        console.error(`'Ошибка загрузки списка ресторанов' - ${error}`)
        dispatch(addTemporaryNotice({ markup: 'Ошибка загрузки списка ресторанов' }))
      })
      .finally(() => {
        dispatch(setLoading({ ...state.loading, items_addition: false }))
      })
  },
)

export const loadPage = createAsyncThunk<void, number, { state: RootState }>(
  'listing/loadPage',
  async (pageNumber, { dispatch, getState }) => {
    const stateGlobal = getState().global
    const state = getState().pages.listing

    const { items_addition, items_full } = state.loading
    if (items_addition || items_full || !state.pagination) return

    dispatch(setLoading({ ...state.loading, items_full: true }))

    const params = {
      page: pageNumber,
      page_size: state.pagination.page.size,
      city: stateGlobal.currentCity.id,
      ...state.paramsRequest,
      optimized: LISTING_RESTAURANT_LIST_OPTIMIZED,
    }

    API.restaurant_list({ params })
      .then((response) => {
        dispatch(setList(response.results))
        dispatch(setPaginationPage(response.pagination))
      })
      .catch((error) => {
        console.error(`'Ошибка загрузки списка ресторанов' - ${error}`)
        dispatch(addTemporaryNotice({ markup: 'Ошибка загрузки списка ресторанов' }))
      })
      .finally(() => {
        dispatch(setLoading({ ...state.loading, items_full: false }))
      })
  },
)

export const loadFullRestaurantForListingCard = createAsyncThunk<void, number, { state: RootState }>(
  'listing/loadFullRestaurantForListingCard',
  async (restaurantId, { dispatch, getState }) => {
    const state = getState().pages.listing
    const restaurant = state.list?.find((item) => item.id === restaurantId)
    if (!restaurant || restaurant.optimizationState === 0 || fullRestaurantRequests.has(restaurantId)) return

    const path = restaurant.url?.slug
    if (!isRestaurantReadSlug(path)) return

    fullRestaurantRequests.add(restaurantId)

    try {
      const fullRestaurant = await API.restaurant_read({ path })
      dispatch(upsertRestaurantInList(fullRestaurant))
    } catch (error) {
      console.error(`'Ошибка загрузки ресторана' - ${error}`)
    } finally {
      fullRestaurantRequests.delete(restaurantId)
    }
  },
)
